import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100 d-flex" }
const _hoisted_2 = { class: "mx-auto" }

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import RightContent from '@/components/DailyReportEdit/Combine/RightContent.vue';
import DeliveryPlan from "@/types/DeliveryPlan";
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RightPane',
  props: {
    modelValue: {},
    deliveryPlan: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const isLastContent = computed(() => (index: number) => {
  return index === modelValue.value.length - 1;
})

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "w-100 mb-8" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineForm.rightPane.title')), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelValue.value, (selectedDeliveryPlan, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: selectedDeliveryPlan.delivery_plan_id,
          class: _normalizeClass(["mx-auto my-5", isLastContent.value(index) ? 'mb-8' : '']),
          style: {"width":"80%"}
        }, [
          _createVNode(RightContent, {
            modelValue: modelValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
            originDeliveryPlan: props.deliveryPlan,
            deliveryPlan: selectedDeliveryPlan
          }, null, 8, ["modelValue", "originDeliveryPlan", "deliveryPlan"])
        ], 2))
      }), 128))
    ]),
    _: 1
  }))
}
}

})